import { render, staticRenderFns } from "./HCenter.vue?vue&type=template&id=5f67d818&scoped=true"
import script from "./HCenter.vue?vue&type=script&lang=js"
export * from "./HCenter.vue?vue&type=script&lang=js"
import style0 from "./HCenter.vue?vue&type=style&index=0&id=5f67d818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f67d818",
  null
  
)

export default component.exports